function healthCheck() {
  return <p>OK</p>;
}

export default healthCheck;
